import "./faq.css";

$(function() {
  $(".faq").on("click", ".faq_question", function() {
    var $item = $(this).closest(".faq_item");
    var open = !$item.hasClass("faq_item_open");

    $item.siblings(".faq_item_open").removeClass("faq_item_open").find(".faq_question").attr("aria-expanded", "false");
    $item.toggleClass("faq_item_open", open);
    $(this).attr("aria-expanded", String(open));
  });
});
